import {
  AccordionDetails,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Stack } from "@mui/system";
import RemoveIcon from "@mui/icons-material/Remove";
import { useStyles } from "./styles";
import React from "react";
import CustomExpandMore from "../../../../../common/CustomExpandMore";
import { ErrorMessage, Formik } from "formik";
import useStudent from "../../../../../Hooks/student";
import * as Yup from "yup";

export const achievementSchema = Yup.object().shape({
  awardName: Yup.string().required("* Please enter award name").nullable(),
  awardYear: Yup.number().required("* Please enter award year").nullable(),
});

const AchievementInfo = (props) => {
  const classes = useStyles();
  const { currentIndex, achievementRef } = props;
  const {
    removeAchievementAction,
    updateAchievementAction,
    achievementsList,
    studentPersonalInfo,
    addAchievementAction,
    addAchievementsAction,
    studentDetails,
    deleteAchiveAction,
  } = useStudent();
  const AchievementInfo = {
    id: achievementsList[currentIndex].id || "",
    idStudent:
      achievementsList && achievementsList[currentIndex]?.idStudent
        ? achievementsList[currentIndex]?.idStudent || ""
        : studentDetails?.id,

    type: achievementsList[currentIndex].type || "",
    level: achievementsList[currentIndex].level || "",
    awardName: achievementsList[currentIndex].awardName || "",
    awardYear: achievementsList[currentIndex].awardYear || "",
  };
  return (
    <Stack sx={{ border: "1px solid #D1D5DB", mb: 2, borderRadius: "23px" }}>
      <Stack
        sx={{
          color: "#25D5A1",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        <Stack
          sx={{
            width: "80px",
            height: "80px",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            borderRadius: "50px",
          }}
          onClick={() => {
            removeAchievementAction({ key: currentIndex });
            deleteAchiveAction({ id: achievementsList[currentIndex]?.id });
          }}
        >
          <RemoveIcon />
        </Stack>
      </Stack>
      <Formik
        validationSchema={achievementSchema}
        initialValues={AchievementInfo}
        validateOnBlur={false}
        innerRef={achievementRef}
        validateOnChange={false}
        enableReinitialize
        onSubmit={
          (values) => {}
          // addAchievementsAction({
          //   achievementsList: [values],
          // })
        }
      >
        {(formik) => {
          const { errors, touched, handleChange, handleSubmit, values } =
            formik;
          return (
            <form id="achievementInfo" onSubmit={handleSubmit}>
              <AccordionDetails>
                <Stack
                  className={classes.awardName}
                  sx={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                   <Stack
                    sx={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 4,
                      mb: 2,
                    }}
                  >
                    <Stack>
                      <TextField
                        id="awardName"
                        name="awardName"
                        placeholder="Enter award name"
                        className={
                          errors.awardName && touched.awardName
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        onChange={(e) => {
                          handleChange(e);
                          updateAchievementAction({
                            type: "awardName",
                            index: currentIndex,
                            data: e.target.value,
                          });
                        }}
                        value={values.awardName}
                      />
                      <ErrorMessage
                        name="awardName"
                        component="span"
                        className={classes.error}
                      />
                    </Stack>
                  </Stack>
                  <Stack
                    sx={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <Stack>
                      <TextField
                        id="type"
                        name="type"
                        placeholder="Enter award type"
                        className={
                          errors.type && touched.type
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        onChange={(e) => {
                          handleChange(e);
                          updateAchievementAction({
                            type: "type",
                            index: currentIndex,
                            data: e.target.value,
                          });
                        }}
                        value={values.type}
                      />
                      <ErrorMessage
                        name="type"
                        component="span"
                        className={classes.error}
                      />
                    </Stack>
                  </Stack>
                  <Stack
                    sx={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 4,
                      mb: 2,
                    }}
                  >
                    <Stack>
                      <TextField
                        id="level"
                        name="level"
                        placeholder="Enter level"
                        className={
                          errors.level && touched.level
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        onChange={(e) => {
                          handleChange(e);
                          updateAchievementAction({
                            type: "level",
                            index: currentIndex,
                            data: e.target.value,
                          });
                        }}
                        value={values.level}
                      />
                      <ErrorMessage
                        name="level"
                        component="span"
                        className={classes.error}
                      />
                    </Stack>
                  </Stack>
                 
                  <Stack
                    sx={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 4,
                      mb: 2,
                    }}
                  >
                    <Stack>
                      <TextField
                        id="awardYear"
                        name="awardYear"
                        type="number"
                        placeholder="Enter award year"
                        className={
                          errors.awardYear && touched.awardYear
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        onChange={(e) => {
                          handleChange(e);
                          updateAchievementAction({
                            type: "awardYear",
                            index: currentIndex,
                            data: e.target.value,
                          });
                        }}
                        value={values.awardYear}
                      />
                      <ErrorMessage
                        name="awardYear"
                        component="span"
                        className={classes.error}
                      />
                    </Stack>
                  </Stack>
                </Stack>
                <Stack
                  className={classes.level}
                  sx={{
                    flexDirection: "row",
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                ></Stack>
              </AccordionDetails>
            </form>
          );
        }}
      </Formik>
    </Stack>
  );
};

export default AchievementInfo;
